module.exports = __webpack_public_path__ + "img/bg_orange_popular.1b96d468.png";